module.exports = __webpack_public_path__ + "img/4-gallery.80d6e58a.png";